import React from 'react';

import {useSelector} from 'react-redux';

import {StyledToastNotificationContainerDiv} from 'app/toasts/components/ToastNotificationsContainer';
import {gt} from 'app/utils/i18n';

// @ts-expect-error https://developer.mozilla.org/en-US/docs/Web/API/Location/reload#location.reload_has_no_parameter
const reloadPage = () => window.location.reload(true);

export function ReloadRequiredModal(): JSX.Element | null {
  const reloadRequired = useSelector(
    (state): boolean => state.settings.reloadRequired
  );

  return reloadRequired ? (
    <StyledToastNotificationContainerDiv>
      <div className="mb-0 mt-2 px-0 alert status-alert alert-info row align-items-center text-center">
        <h4 className="mb-3 mb-md-0 col-12 col-md-4">
          {gt('SweetProcess has updated!')}
        </h4>
        <div className="mb-2 mb-md-0 col-12 col-md-5">
          {gt('Please reload the page to continue using SweetProcess.')}
        </div>
        <div className="col-12 col-md-3 pl-md-0center">
          <button className="btn btn-link" onClick={reloadPage}>
            <i className="fa fa-sync" /> {gt('Reload')}
          </button>
        </div>
      </div>
    </StyledToastNotificationContainerDiv>
  ) : null;
}
